/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.21/esri/copyright.txt for details.
*/
const r=(()=>{const r=new Array;return r[0]=10,r[1]=10,r[2]=10,r[3]=10,r[4]=5,r})(),n=30;export{r as downloadSlotsPerClient,n as maxDownloadSlots};
